var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-survey__inner c-survey__bg--blue" }, [
    _c("div", { staticClass: "c-survey__content c-survey__content--padding" }, [
      _c("main", {
        staticClass: "c-survey__html",
        domProps: { innerHTML: _vm._s(_vm.pageTwo.content) },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "c-survey__accordion" },
        _vm._l(_vm.sections, function (section, index) {
          return _c(
            "div",
            { key: index, staticClass: "c-survey__accordion-item" },
            [
              _c(
                "div",
                {
                  staticClass: "c-survey__accordion-item-header",
                  style: { backgroundColor: section.sectionColour },
                  on: {
                    click: function ($event) {
                      return _vm.toggleDescription(`${index}Visible`)
                    },
                  },
                },
                [
                  _c(
                    "h2",
                    {
                      staticClass: "white-text c-survey__accordion-item-title",
                    },
                    [_vm._v(_vm._s(section.label))]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    class: [
                      "c-survey__accordion-indicator",
                      _vm.sectionsVisibility[`${index}Visible`]
                        ? "c-survey__accordion-indicator--active"
                        : "",
                    ],
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "transition",
                {
                  attrs: { name: "accordion-slide-fade" },
                  on: {
                    "before-enter": _vm.beforeEnter,
                    enter: _vm.enter,
                    leave: _vm.leave,
                  },
                },
                [
                  _vm.sectionsVisibility[`${index}Visible`]
                    ? _c(
                        "div",
                        {
                          staticClass: "c-survey__accordion-item-content",
                          style: { backgroundColor: section.sectionColour },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "c-survey__accordion-content-wrapper",
                            },
                            [
                              _c("main", {
                                staticClass: "c-survey__html",
                                domProps: {
                                  innerHTML: _vm._s(section.description),
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "c-survey__actionbutton-row c-survey__actionbutton-row--center",
        },
        [
          _c("ActionButton", {
            attrs: {
              title: _vm.pageTwo.prevLabel,
              buttonAction: "prev",
              arrowLeft: true,
              muted: true,
            },
          }),
          _vm._v(" "),
          _c("ActionButton", {
            attrs: { title: _vm.pageTwo.nextLabel, buttonAction: "next" },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }